import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/inventories'

const InventoriesApiV2 = {
  get: async ({ tableState }) => {
    const params   = QueryParamsUtil.format(tableState)
    const response = axios.get(API_PATH, { params })
    return response
  },

  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  updateLocation: async ({
    inventory_id,
    old_location_id,
    new_location_id,
    quantity
  }) => {
    const endpoint = `${API_PATH}/${inventory_id}/update_location`
    const payload  = {
      'inventory': {
        'old_location_id' : old_location_id,
        'new_location_id' : new_location_id,
        'quantity'        : quantity
      }
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * Update inventory quantity and create inventory movement
   * Invoke `POST api/v2/admins/inventories/:id/fix_data
   */
  fixData: async (params, inventory_id) => {
    const path     = `${API_PATH}/${inventory_id}/fix_data`
    const payload  = {
      inventory_movement: params
    }
    const response = axios.post(path, payload)
    return response
  },

  /**
   * Get list of Inventoriess using csv
   * Invoke `POST api/v2/admins/inventories/csv
   * @param {BinaryType} file - csv file
   */
  indexCsv: async (file) => {
    const path  = `${API_PATH}/index_csv`
    let payload = new FormData()
    payload.append('file', file)
    const response = await axios.post(path, payload)
    return response
  }
}

export default InventoriesApiV2